// @flow
import React from "react";
import PropTypes from "prop-types";
import { TreeSelect } from "antd";
import type { Category } from "../../reducers/categories";

const TreeNode = TreeSelect.TreeNode;

type Props = {
  placeholder: string,
  treeData: Array<Category>,
  selectedNodes: Array<string>,
  onSelectNode: Function
};

const CategoryTreeSelect = ({
  placeholder,
  onSelectNode,
  selectedNodes,
  treeData
}: Props) => {
  const SHOW_PARENT = TreeSelect.SHOW_PARENT;

  const filterCategories = (inputValue, treeNode) => {
    const index = treeNode.props.title
      .toLowerCase()
      .indexOf(inputValue.toLowerCase());
    let containsString = index !== -1;
    return containsString;
  };

  const renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={item.label} key={item.key} dataRef={item} {...item}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode title={item.label} key={item.key} dataRef={item} {...item} />
      );
    });
  };

  const tProps = {
    multiple: true,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    searchPlaceholder: placeholder,
    filterTreeNode: filterCategories,
    allowClear: true
  };
  return (
    <TreeSelect
      className="search-panel-element"
      {...tProps}
      value={selectedNodes}
      onChange={onSelectNode}
      getPopupContainer={triggerNode => triggerNode.parentNode}
    >
      {renderTreeNodes(treeData)}
    </TreeSelect>
  );
};

export default CategoryTreeSelect;

CategoryTreeSelect.propTypes = {
  placeholder: PropTypes.string.isRequired,
  treeData: PropTypes.array.isRequired,
  selectedNodes: PropTypes.array.isRequired,
  onSelectNode: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/category-tree-select/index.js